import React, { useEffect, useState } from 'react'
import PrivacyPolicyTemplate from './PrivacyPolicyTemplate'
import { API_BASE_URL } from 'configs/AppConfig';

function TermsofUse() {

  const [list, setList] = useState()

  const fetchData = async () => {
    const response = await fetch(`${API_BASE_URL}information-policy/getBySlug/terms-of-use`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    const data = await response.json();
    setList(data?.data);
    console.log('data pages', data)

    if (!response.ok) {
      // message.error(data.message);
      throw new Error(data.message);
    }

    
    // return data.data;
  }

  useEffect(()=>{
    fetchData()
  },[])

  return (
    <div>
      <PrivacyPolicyTemplate title="TERMS OF USE" data={list} />
    </div>
  )
}

export default TermsofUse
